import { useSessionStore } from "../../../stores/UserStore";
import { Stack } from "@mantine/core";
import {
  IconAddressBook,
  IconHelp,
  IconSettings,
  IconSpeakerphone,
  IconTimelineEvent,
} from "@tabler/icons-react";

export function getKnowledgesIT() {
  const reseller = useSessionStore.getState().reseller;

  const result = [
    {
      url: "contact-lists",
      icon: IconAddressBook,
      title: "Liste di contatti",
      desc: "Tutte le informazioni sulle liste di contatti",
      items: [
        {
          url: "filters",
          title: "Filtrare i miei contatti in una lista",
          content: (
            <Stack>
              <p>
                Una volta creata la tua lista, avrai la possibilità di
                ordinarla. Se non ti soddisfa, o se desideri filtrarla, puoi
                allora escludere dei contatti. <br />
              </p>
              <p>
                Sulla pagina Contatti, puoi cliccare sul nome della tua lista e
                vedrai apparire il dettaglio della tua lista.
                <br />
              </p>
              <p>
                Troverai notamment sopra la tua lista, un'icona “Filtri” che ti
                permetterà di escludere dei contatti dalla tua lista,
                <br />
              </p>
              <p>
                Per esempio: Desidero eliminare tutti i contatti la cui
                “funzione” contiene “Assistente”.{" "}
              </p>
            </Stack>
          ),
        },
        {
          url: "page",
          title: "Funzionalità della pagina Contatti",
          content: (
            <Stack>
              <p>
                La scheda Lista ti permette di ritrovare l'insieme delle tue
                liste di contatti al fine di realizzare le tue campagne di
                prospezione.
                <br />
                <br />
              </p>
              <p>
                Vi ritroverai tutte le funzionalità e gli strumenti per una
                buona gestione delle tue liste di contatti
                <br />
              </p>
              <ul>
                <li>
                  Creazione di liste a partire dalla nostra base di contatti B2B
                  <br />
                </li>
                <li>Creazione di liste a partire da LinkedIn</li>
                <li>Creazione delle tue liste a partire da Google</li>
                <li>Importazione delle tue liste</li>
              </ul>

              {/* Image here */}

              <p>
                <b>
                  VISTA DELLE CARTELLE
                  <br />
                </b>
              </p>
              <ul>
                <li>
                  Mostra tutte le liste
                  <br />
                </li>
                <li>Crea una cartella</li>
                <li>Rinomina una cartella</li>
                <li>Elimina una cartella</li>
                <li>Cerca una cartella</li>
              </ul>
              <p>
                <b>
                  <br />
                  COLONNA ''AZIONE''
                  <br />
                  Pulsante ''Matita'' puoi:
                </b>
              </p>
              <ul>
                <li>Rinominare la tua lista</li>
                <li>Aggiungere dei Tag</li>
                <li>Creare e spostare la tua lista in una cartella</li>
              </ul>
              <p>
                <br />
              </p>
              <p></p>
              <p>
                <b>Pulsante ''+'' potrai:</b>
                <br />
              </p>
              <ul>
                <li>Vedere i contatti della tua lista in una nuova scheda</li>
                <li>Importare una lista di contatti da un file</li>
                <li>Importare una lista di contatti tramite copia-incolla</li>
                <li>Scaricare il tuo file in CSV o XLSX</li>
                <li>Duplicare la tua lista</li>
                <li>Copiare una lista a un utente, un team, un'azienda</li>
                <li>Copiare la tua lista nel PRM</li>
                <li>Dividere la tua lista in X liste (splitter)</li>
              </ul>
              <p>
                <br />
              </p>
              <p>
                <b>Pulsante ''Cestino''</b>
                <br />
              </p>
              <ul>
                <li>Eliminare la tua lista</li>
              </ul>
              <p>
                <br />
                <b>INFO </b>: Puoi selezionare più liste al fine di realizzare
                simultaneamente una delle azioni
              </p>

              {/* Image here */}

              <p>
                <b>COLONNA "AZIONE"</b>
              </p>
              <ul>
                <li>Scaricare i tuoi contatti in CSV o XLSX</li>
                <li>
                  Duplicare la selezione dei tuoi contatti in una nuova lista
                </li>
                <li>Copiare una lista a un utente, un team, un'azienda</li>
                <li>
                  Copiare la selezione dei tuoi contatti a un utente, un team,
                  un'azienda
                </li>
                <li>Copiare la selezione dei tuoi contatti al PRM</li>
                <li>
                  Dividere la selezione dei tuoi contatti in X liste (splitter)
                </li>
              </ul>
              <p>
                <br />
              </p>
              <p>
                <b>Pulsante ''Cestino''</b>
              </p>
              <ul>
                <li> Eliminare la tua lista</li>
              </ul>
              <p></p>
              <p></p>

              {/* Image here */}

              <p>
                <b>
                  Barra degli strumenti di accesso rapido
                  <br />
                </b>
              </p>
              <ul>
                <li>Cercare in una lista o nelle cartelle</li>
                <li>Filtro di ricerca multicriterio con condizioni</li>
                <li>Gestione della visualizzazione delle colonne</li>
                <li>Esportare una lista o una cartella</li>
                <li>Eliminare una lista o una cartella</li>
              </ul>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "configurations",
      icon: IconSettings,
      title: "Configurazioni",
      desc: "Configurare il software di prospezione",
      items: [
        {
          url: "add-exclusions",
          title: "Creare le tue liste di disiscritti o di Blacklist",
          content: (
            <Stack>
              <p>
                Sulla piattaforma, hai la possibilità di escludere dei contatti
                dalle tue campagne.
                <br />
                <br />
                Così non riceveranno i tuoi messaggi e saranno esclusi
                automaticamente dalle tue campagne / scenari.
                <br />
                <br />{" "}
              </p>
              <p>
                È un principio di precauzione al fine di non sollecitare i tuoi
                prospect, clienti, partner, fornitori, ecc... senza dover
                controllare manualmente ogni contatto della tua lista prima
                dell'invio della tua campagna.
                <br />
                <br />
              </p>
              <p>Per fare ciò, è sufficiente:</p>
              <p>
                {" "}
                Importare una lista di contatti sotto forma di file CSV qui{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/exclusions/blacklists`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /exclusions/blacklists.
                  <br />
                </a>
                OPPURE cliccare sulla scheda “Configurazione" &gt; “Blacklist"
                &gt; “Importare” una lista di contatti da respingere. <br />
                <br />
                Puoi anche creare delle cartelle delle tue liste da respingere
                per tipologia di esclusione come i tuoi clienti, le persone da
                non contattare mai...
                <br />
                <br />
              </p>
              <p>
                Le chiavi di disiscrizione prese in considerazione dal sistema
                sono: l’email, il nome di dominio, il SIRET, il SIREN, il link
                LinkedIn o la ragione sociale.
                <br />
                <br />
              </p>
              <p>
                <b>Per disiscrivere definitivamente dei contatti</b>, Bisogna
                andare su questa pagina:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/exclusions/unsubscribers`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /exclusions/unsubscribers
                </a>{" "}
                .<br />
                O cliccare sulla scheda “Configurazione" &gt; “Lista dei
                disiscritti”
                <br />
                <br />
              </p>
              <p>
                <b>Attenzione</b>: Il file deve contenere una sola informazione
                per riga. <br />
                Queste informazioni possono essere mescolate nel tuo file
                d'importazione.
                <br />
                <b>
                  <br />
                </b>
              </p>
              <p>
                <b>
                  La differenza tra una lista di esclusione e una disiscrizione:
                  <br />
                  <br />
                </b>
              </p>
              <p>
                {" "}
                <b>La disiscrizione </b>è automatica e irreversibile: Una volta
                che il contatto è marcato come disiscritto, puoi essere certo
                che non riceverà più nulla da parte tua.
                <br />
                <br />
              </p>
              <p>
                {" "}
                <b>La base di esclusione</b> si seleziona ad ogni campagna in
                funzione della tua volontà o meno di prenderla in considerazione
                su ogni invio.
              </p>
            </Stack>
          ),
        },
        {
          url: "connect-email",
          title: "Connettere il mio account e-mail",
          content: (
            <Stack>
              <p>
                Prima di lanciare una campagna e-mail, bisogna fare attenzione
                al metodo d’invio e all’e-mail mittente scelta.
              </p>
              <p>Avrai così due alternative:</p>
              <ol>
                <li>
                  {" "}
                  Invio in mass mailing: ciò permette di inviare campagne a
                  grandi volumi e rapidamente, ma con un tasso di apertura meno
                  importante.
                  <br />
                  Gli invii (routing) avvengono attraverso la piattaforma
                  {reseller?.name}. Hai la possibilità di configurare un alias
                  al momento dell'invio. Un alias (artefatto) è la mail che sarà
                  vista dai tuoi prospect, ma che non sarà utilizzata durante
                  gli invii.
                  <br />
                  <b>Attenzione</b>, {reseller?.name} non apparirà mai durante i
                  tuoi invii in mass mailing
                </li>
                <li>
                  {" "}
                  Invio dalla tua casella e-mail: Ciò permette di aumentare i
                  tuoi tassi di risposta comunicando con ogni prospect a un
                  livello individuale.
                </li>
              </ol>
              <p>
                {" "}
                Puoi connettere le tue caselle e-mail alla piattaforma. Potrai
                vedere, al momento dell'invio della campagna, le e-mail inviate
                nella tua scheda «E-mail inviate» sulla tua casella mail.{" "}
              </p>
              <p>
                Attenzione, ti raccomandiamo di limitare gli invii a 100 e-mail
                / giorno per e-mail mittente.
                <br />
                <br />
              </p>
              <p>
                <b>
                  Per configurare le tue e-mail, ti invitiamo a cliccare sul
                  link:{" "}
                </b>
              </p>
              <p>
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/senders/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /senders/email
                </a>{" "}
                o vai sulla scheda ‘’Strumento’’ &gt; Email mittenti
              </p>
              <p>Avrai due possibilità:</p>
              <ol>
                <li>
                  {" "}
                  Clicca su ‘’Aggiungi la tua email come mittente’’ (pulsante
                  blu) che corrisponde all’aggiunta di un alias mass mailing.
                  <br />- Inserisci la tua e-mail poi valida su ‘’Registra’’.
                  Riceverai un’e-mail di validazione sulla tua casella email per
                  assicurarci che il dominio ti appartenga.
                </li>
                <li>
                  {" "}
                  Clicca su “Invia la tua e-mail dal tuo dominio SMTP’’
                  (pulsante verde) che corrisponde alla connessione della tua
                  casella mail.
                </li>
              </ol>
              <p>
                {" "}
                All'apertura del pop-up, seleziona il fornitore del tuo account
                e-mail
              </p>
              <ul>
                <li>
                  Per Gmail o Outlook, seleziona l'indirizzo e-mail che desideri
                  aggiungere poi segui le tappe seguenti.
                </li>
                <li>
                  Per gli altri fornitori e-mail, inserisci le informazioni
                  richieste.
                  <br />
                  <br />
                </li>
              </ul>
              <p>
                <b>Configurazione complementare:</b>
              </p>
              <p>
                Queste opzioni ti permetteranno di ottimizzare la buona
                ricezione delle tue e-mail:
              </p>
              <ul>
                <li> Attivare / Disattivare il link di disiscrizione.</li>
                <li>
                  {" "}
                  Attivare / Disattivare il tracking degli apritori/cliccatori.
                </li>
                <li>
                  {" "}
                  Frequenze degli invii: Lasso di tempo tra due invii di
                  un’e-mail.
                </li>
                <li>
                  {" "}
                  Warm UP: Preriscaldamento di un’e-mail (tecnica di
                  preservazione della reputazione IP).
                </li>
                <li>
                  {" "}
                  Pool SMTP: Poter collegare le tue e-mail mittenti a un pool
                  SMTP.
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "email-validation",
          title: "Validazione di un E-mail",
          content: (
            <Stack>
              <p>
                <i>
                  <b>Domanda </b>: Ho ricevuto la mail di validazione
                  dell'aggiunta di un account E-mail proveniente da:{" "}
                  <a
                    href={`http://${
                      reseller?.domain_saas3 || reseller?.domain_saas2
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {reseller?.domain_saas3 || reseller?.domain_saas2}
                  </a>{" "}
                  info@{reseller?.domain_saas3 || reseller?.domain_saas2} il che
                  mi sembra anormale.
                </i>
              </p>
              <br />
              <p>
                <b>Risposta </b>: Non è un errore, perché la validazione di un
                nuovo account (procedura di sistema) proviene dalla piattaforma{" "}
                <b>{reseller?.name}</b>.<br />
              </p>
              <p>
                Al fine di disporre di un mittente personalizzato per gli avvisi
                o le validazioni del software, bisogna cambiare piano per
                passare a Marca Bianca.
                <br />
              </p>
              <p>
                Si prega di contattare il servizio commerciale a questo
                proposito
              </p>
            </Stack>
          ),
        },
        {
          url: "create-signature",
          title: "Creare le tue firme e-mail",
          content: (
            <Stack>
              <p>
                Quando crei un’e-mail, puoi aggiungere al contenuto la tua
                firma. <br />
              </p>
              <p>
                Per fare ciò, puoi preventivamente importare sulla piattaforma
                la tua firma.
              </p>
              <p>
                Clicca sul link{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email-signature`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email-signature
                </a>{" "}
                poi clicca sul pulsante ‘’Creare una firma’’
              </p>
              <p>
                O vai sulla scheda “Configurazioni" &gt; Firme delle E-mail.
                <br />
              </p>
              <p>
                Una volta aggiunta la tua firma, quando modificherai o creerai
                il tuo modello di scenario, puoi cliccare sul pulsante ''Firma''
                per aggiungere la tua firma scegliendo una delle firme già
                create. <br />
                <br />
              </p>
              <p>
                <b>INFO </b>: Durante la creazione dei tuoi messaggi e-mail,
                potrai comunque previsualizzare il tuo messaggio con la firma
                voluta
              </p>
              <p></p>
            </Stack>
          ),
        },
        {
          url: "dynamic-columns",
          title: "Colonne dinamiche",
          content: (
            <Stack>
              <p>
                Le colonne dinamiche sono utilizzate durante un'importazione di
                una lista di contatti e quando le colonne nel tuo file non sono
                state previste e create dal software.
              </p>

              {/* Image here */}

              <p>
                Al fine di ovviare a questa mancanza di colonne, durante
                l'importazione del tuo file, hai la possibilità di creare queste
                colonne dinamiche.
                <br />
                <br />
              </p>
              <p>
                Per la gestione di queste colonne: l'aggiunta o la soppressione,
                puoi andare qui:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/settings/tools/datafields`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /settings/tools/datafields
                </a>
              </p>
              <p>O nella scheda ''Configurazioni'' -&gt; colonne dinamiche</p>
              <p>
                <br />
                Nella colonna ''<b>Azione</b>'', puoi:{" "}
              </p>
              <p>
                <b>Eliminare </b>: permette di eliminare la colonna dinamica.
              </p>
              <p>
                <br />
                <b>ATTENZIONE </b>: Questa azione di eliminare una colonna
                dinamica eliminerà anche <b>TUTTI I DATI</b> di questa colonna{" "}
                <br />
                <br />
                La colonna ''<b>Condivisione</b>'' ti permette di condividere
                questa colonna con i tuoi collaboratori, un team o un'azienda.
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "campaigns",
      icon: IconSpeakerphone,
      title: "Campagne",
      desc: "Le basi sui tuoi invii di campagne",
      items: [
        {
          url: "statistics",
          title: "Statistiche delle tue campagne",
          content: (
            <Stack>
              <p>
                Sulla piattaforma {reseller?.name}, disponi delle statistiche
                delle tue campagne.
                <br />
              </p>
              <p>
                Sul tuo dashboard troverai il numero di email inviate, email
                programmate, email cliccate, email aperte, email ricevute.
                <br />
              </p>
              <p>
                Per le campagne LinkedIn, i KPI da seguire saranno i tassi di
                accettazione dei tuoi inviti (livello di relazione 1), i tassi
                di risposta e i tassi di lettura dei tuoi messaggi (livello di
                relazione 2 e 3).
                <br />
              </p>
              <p>
                I dati sono riprodotti sotto forma di tabella: così hai le
                statistiche che analizzano le tue campagne organizzate campagna
                per campagna.
                <br />
              </p>
              <p>
                Clicca sul link:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/statistics/campaigns`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /statistics/campaigns
                </a>
              </p>
              <p>O vai sulla scheda ‘’Campagne’’</p>
              <p>
                <br />
                <b>Nella tabella troverai:</b>
              </p>
              <ul>
                <li>
                  {" "}
                  Le email programmate: il numero di email che sono in corso di
                  esecuzione.
                </li>
                <li>
                  {" "}
                  Il numero di email inviate a partire dalle email programmate.
                </li>
                <li>
                  {" "}
                  Le email aperte: Il numero di email aperte alla loro
                  ricezione.
                </li>
                <li>
                  {" "}
                  Le email cliccate: il numero di email in cui c'è un link sul
                  quale il ricevente ha cliccato.
                </li>
                <li>
                  {" "}
                  Il numero delle risposte ricevute a seguito dell'invio delle
                  email.
                </li>
              </ul>
              <p>
                <br />
                Se desideri più dettagli e accedere alle statistiche d'invio
                giornaliere, puoi cliccare sull'icona “Rapporto” a destra di
                ciascuna delle tue campagne sulla scheda delle statistiche.{" "}
              </p>
            </Stack>
          ),
        },
        {
          url: "view-campaigns",
          title: "Ritrovare le mie campagne programmate",
          disabled: true,
          content: (
            <Stack>
              <p>
                Hai la possibilità di vedere tutte le tue campagne una volta che
                sono programmate cliccando sulla scheda “Campagne”:
                <br />
              </p>
              <p>
                Puoi filtrare rapidamente le tue campagne scegliendo “In corso,
                In pausa, Errore, Archiviato''
                <br />
                <br />
                Puoi anche utilizzare i filtri multi-criterio tramite la
                funzione ''Filtri''
                <br />
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "leads-tracking",
      icon: IconAddressBook,
      title: "Tracciamento dei lead",
      desc: "Gestione della Relazione con i Prospect",
      items: [
        {
          url: "general",
          title: "Tracciamento dei lead in generale",
          disabled: true,
          content: (
            <Stack>
              <p>
                Per ogni campagna inviata, il sistema crea una cartella sulla
                piattaforma nella quale archivia i tuoi contatti attivi: è il
                PRM (Gestione della Relazione con i Prospect).
                <br />
              </p>
              <p>
                Non si gestisce un PRM come si gestisce un CRM (Gestione della
                Relazione con i Clienti).
                <br />
              </p>
              <p>
                Per una ragione abbastanza semplice da capire: un cliente, non è
                un prospect e non ci rivolgiamo allo stesso modo a un cliente
                come a un prospect.
                <br />
              </p>
              <p>
                Le procedure relazionali e le azioni che ne derivano sono
                diverse!
              </p>
              <p>
                A differenza di un CRM, il PRM permette di automatizzare compiti
                di rilancio attraverso lo scenario, di orientare il prospect
                verso nuovi cicli di prospezione, di attivare il nurturing in
                funzione del suo stato: interessato, non ancora pronto...
                <br />
              </p>
              <p>
                Così, in ogni cartella, ritroverai i prospect di ogni campagna
                in modo indipendente: gli apritori, i cliccatori, coloro che
                hanno risposto, le persone che hanno accettato il tuo invito
                LinkedIn, le persone che ti hanno risposto su LinkedIn, ecc.
                <br />
              </p>
              <p>
                Il PRM è accessibile su{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/leads-tracking`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /leads-tracking
                </a>{" "}
              </p>
              <p>
                o tramite la scheda “PRM”.
                <br />
              </p>
              <p>
                In ogni cartella PRM, ritroverai così i tuoi contatti attivi,
                classificati per stato e per ordine di scoring decrescente.
                <br />
              </p>
              <p>
                Puoi anche sincronizzare automaticamente nel tuo CRM dopo aver
                creato una sincronizzazione con {reseller?.name} o scaricare i
                tuoi contatti attivi e lavorarli direttamente sul tuo CRM
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "workflows",
      icon: IconTimelineEvent,
      title: "Scenario",
      desc: "Tutto sugli scenari",
      items: [
        {
          url: "create-email",
          title: "Creare uno scenario",
          content: (
            <Stack>
              <p>
                Sulla piattaforma puoi creare degli scenari che rappresentano
                una successione di azioni innescate a condizioni predefinite.
                <br />
                <br />
              </p>
              <p>
                Per creare un nuovo scenario, ti invitiamo ad andare su questo
                link:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/campaign/create`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /campaign/create
                  <br />
                  <br />
                </a>
              </p>
              <p>
                O vai sulla scheda “I miei scenari" &gt; Creare un nuovo
                scenario &gt; Aggiungere un nome di scenario.
                <br />
                <br />
              </p>
              <p>Ecco la procedura da seguire per creare uno scenario:</p>
              <ol>
                <li>
                  Scegli il canale che desideri tra LinkedIn / Email / SMS /
                  Messaggio vocale.
                </li>
                <li>
                  {" "}
                  Primo messaggio: Aggiungi il tuo messaggio di prospezione alla
                  tua arborescenza di scenario cliccando sul piccolo più sotto
                  l'azione iniziale.
                </li>
                <li>
                  {" "}
                  Rilancio: Scegli il canale tramite il quale desideri fare il
                  rilancio.
                </li>
                <li>
                  {" "}
                  Seleziona la popolazione che riceverà il tuo rilancio
                  (apritori, cliccatori, non attivi, persone che hanno accettato
                  il tuo invito su LinkedIn, ecc.) e il termine entro il quale
                  partirà il tuo rilancio.
                </li>
                <li> Aggiungi i contenuti dei tuoi messaggi di rilancio.</li>
                <li>
                  {" "}
                  Registra il tuo scenario.
                  <br />
                  <br />
                </li>
              </ol>
              <p>
                <b>Attenzione</b>, assicurati di aver precedentemente creato i
                tuoi diversi messaggi sul link:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email
                </a>{" "}
                o andando sulla scheda ‘’I miei modelli di email’’
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "faq-guides-questions",
      icon: IconHelp,
      title: "FAQ, GUIDE E DOMANDE",
      desc: "Domande frequenti sull'applicazione",
      items: [
        {
          url: "smtp-limit",
          title: "Limite SMTP raggiunto",
          content: (
            <Stack>
              <p>
                <b>Domanda </b>:{" "}
                <i>
                  Sto provando a inserire nuove email mittenti, e quando arrivo
                  alla fine dell'inserimento mi appare un messaggio di errore
                  che dice: LIMITE SMTP raggiunto
                </i>
              </p>

              <br />
              <p>
                <b>Risposta </b>: Hai raggiunto il limite del numero di account
                da integrare nel software.
              </p>
              <p>
                Bisogna verificare il limite del numero di account della tua
                offerta.
                <br />
              </p>
              <p>
                Se desideri disporre di più account SMTP, si prega di passare a
                un'offerta superiore
              </p>
            </Stack>
          ),
        },
        {
          url: "edit-sender-name",
          title: "Come modificare il nome del mittente?",
          content: (
            <Stack>
              <p>
                <b>Domanda </b>:{" "}
                <i>
                  Quando un prospect risponde a una mail, ricevo questa mail da
                  ''Nicolas de {reseller?.name}''. Come modificare il nome del
                  mittente?
                </i>
              </p>
              <br />
              <p>
                <b>Risposta </b>: Quando crei/modifichi la tua email qui:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email
                </a>
                <br />
                <br />
              </p>
              <p>
                A destra del campo «e-mail di ritorno» hai un «+» che ti
                permette di scegliere l'opzione della risposta
                <br />
              </p>
              <ol>
                <li>
                  ==&gt; Opzione 01: Ricevi l'e-mail in diretto come se il tuo
                  prospect ti rispondesse direttamente senza che la risposta
                  passi per la nostra piattaforma. A quel punto, non avrai più i
                  problemi segnalati, ma non potremo salvare la risposta
                  ricevuta all'interno della nostra piattaforma
                  <br />
                  <br />
                </li>
                <li>
                  ==&gt; Opzione 02: (quella selezionata al momento) Quando il
                  prospect risponde, risponde al nostro server che ti
                  ritrasferisce l'e-mail, è la ragione per cui vedi apparire
                  «Nicolas de {reseller?.name}». Questa soluzione ci permette di
                  salvare la risposta del prospect all'interno della
                  piattaforma.
                  <br />
                  <br />
                </li>
              </ol>
              Con questa soluzione, una volta che ricevi la risposta, è meglio
              aprire una nuova conversazione per continuare lo scambio con il
              tuo prospect.
            </Stack>
          ),
        },
        {
          url: "checkout-failed",
          title: "Perché il mio pagamento con carta fallisce?",
          content: (
            <Stack>
              <p>
                Utilizziamo un sistema di pagamento sicuro (3D secure) approvato
                dall'ACPR, sotto il numero 16568 al fine di proteggere i tuoi
                acquisti.
                <br />
                <br />
              </p>
              <p>
                Verifica la ricezione di un SMS al fine di validare il tuo
                acquisto. <br />
                Se il problema persiste, contattaci.
              </p>
            </Stack>
          ),
        },
        {
          url: "segment-contact-list",
          title: "È possibile segmentare le mie liste di contatti?",
          content: (
            <Stack>
              <p>
                <b>Sì, </b>creando tante liste di contatti di prospezione quante
                ne desideri.
                <br />
                <br />
              </p>
              <p>
                Grazie ai nostri filtri intelligenti, puoi combinare i filtri di
                ricerca: Funzione, settore di attività, codice NAF, Effettivo,
                Cifra d'affari, appellativo, centro d'interesse, centro di
                competenze…
                <br />
                <br />
              </p>
              <p>
                Se ti manca un filtro tra i nostri 20 filtri, non esitare a
                chiedercelo.
              </p>
            </Stack>
          ),
        },
        {
          url: "database-reactive",
          title: "La vostra base di contatti è reattiva?",
          content: (
            <Stack>
              <p>
                <b>Sì</b>, perché le nostre basi sono testate durante l'invio
                degli emailing per i nostri clienti.
                <br />
              </p>
              <p>
                Grazie ai tracciatori che mettiamo nelle nostre mail durante
                l'invio, ci è possibile controllare se il prospect apre la sua
                casella e-mail.
                <br />
              </p>
              <p>
                Se un prospect non apre la sua casella mail nel mese, mettiamo
                in isolamento questo contatto al fine di non prospectarlo più.
                <br />
              </p>
              <p>
                Ciò ci permette di disporre di una base di contatti B2B
                reattiva.
                <br />
              </p>
            </Stack>
          ),
        },
        {
          url: "is-it-french",
          title: "La vostra soluzione è sviluppata in Francia?",
          content: (
            <Stack>
              <p>
                <b>Sì</b>, la nostra soluzione è 100% Francese
                <br />
              </p>
              <ul>
                <li> È sviluppata in Francia</li>
                <li> È ospitata su server sicuri e in Francia da OVH</li>
                <li>
                  {" "}
                  Tutti i dati di {reseller?.name} e dei nostri clienti saranno
                  archiviati su server sicuri in Francia
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "what-is-your-data-sources",
          title: "Quali sono le fonti dei vostri file",
          content: (
            <Stack>
              <p>
                Le principali fonti della nostra base di dati professionali B2B
                provengono da file già costituiti da annuari professionali
                specializzati e leader nei loro domini:
                <br />
              </p>
              <ul>
                <li> I dati pubblici dei social network</li>
                <li>
                  {" "}
                  La base di dati di informazioni legali dell'INSEE, Infogreffe,
                  il Bodacc, Legi France, RNCS…
                </li>
                <li>
                  {" "}
                  Della CCI: Il portale delle Camere di Commercio e Industria
                </li>
                <li> L'annuario ufficiale degli artigiani</li>
                <li>
                  {" "}
                  Gli annuari ad accesso libero: Vérif.com, Societe.com,{" "}
                  <a
                    href={`http://Kompass.fr`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Kompass.fr
                  </a>{" "}
                  …
                </li>
                <li>
                  {" "}
                  I file in OpenData delle amministrazioni pubbliche, della
                  sanità, dell'educazione, delle associazioni…
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "database-constitution",
          title: "Come è costituita la vostra base di contatti B2B?",
          content: (
            <Stack>
              <p>
                Grazie ai nostri script e ai nostri algoritmi intelligenti,
                aggreghiamo tutti
              </p>
              <p>
                i giorni più di 20 fonti di file di professionisti qualificati.
                <br />
              </p>
              <p>
                I profili della nostra base B2B sono strutturati, fusi e
                arricchiti e riverificati quotidianamente.
              </p>
            </Stack>
          ),
        },
        {
          url: "does-it-follow-rgpd-guidelines",
          title: "La vostra soluzione è conforme alla regolamentazione RGPD?",
          content: (
            <Stack>
              <p>
                <b>Sì</b>, la nostra soluzione è conforme al RGPD (Regolamento
                Generale sulla Protezione dei Dati Personali).
                <br />
              </p>
              <p>
                Si tratta di un regolamento adottato dal parlamento europeo il
                14 aprile 2016 ed entrato in vigore nell'Unione Europea il 24
                maggio 2018.
                <br />
              </p>
              <ul>
                <li>
                  La nostra base è costituita da informazioni che raccogliamo a
                  partire da più di 20 fonti di file di professionisti
                  qualificati e in Open-data così come dati Insee, che
                  aggreghiamo e strutturiamo attraverso i nostri algoritmi
                  intelligenti.
                </li>
                <li>
                  {" "}
                  Lavoriamo solo su dati B2B, non soggetti al consenso
                  preliminare come stipula l'articolo 6 del CNIL dalla direttiva
                  e-Privacy che prevale sul RGPD, e trasposta in diritto
                  francese.
                </li>
                <li>
                  {" "}
                  Rispettiamo l'obbligo di mettere un link di disiscrizione su
                  ogni campagna dei nostri clienti.
                </li>
                <li>
                  {" "}
                  Se il cliente dimentica di mettere un link di disiscrizione o
                  è scritto male, allora il nostro sistema lo rileva e aggiunge
                  AUTOMATICAMENTE un link di disiscrizione in chiaro in fondo
                  alla pagina.
                </li>
                <li>
                  {" "}
                  Di informare l'internauta delle informazioni che deteniamo,
                  dell'origine della raccolta così come della cancellazione
                  delle sue informazioni che deteniamo.
                </li>
                <li>
                  {" "}
                  Possiamo anche escludere la mail, il dominio o il Numero SIREN
                  delle aziende che lo richiedono al fine di non prospectarle
                  più.
                </li>
                <li>
                  {" "}
                  Ogni cliente potrà importare le sue liste (crittografia MD5)
                  dei contatti, domini o SIREN da escludere dalle tue campagne.
                </li>
              </ul>
            </Stack>
          ),
        },
      ],
    },
  ];

  if (reseller?.name === "Magileads") {
    result[0].items.unshift(
      {
        url: "import-linkedin",
        title: "Creare una lista a partire da LinkedIn",
        content: (
          <Stack>
            <p>
              Con {reseller?.name}, puoi creare delle liste di contatti a
              partire da una ricerca su LinkedIn o Sales Navigator. Devi quindi
              disporre di un account LinkedIn.
              <br />
            </p>
            <p>
              Il principio è semplice, a partire dal tuo account LinkedIn, fai
              una ricerca di contatti sul sito di LinkedIn e copia/incolla il
              link della tua ricerca sulla piattaforma
              {reseller?.name}.
              <br />
            </p>
            <p>
              Così, il sistema creerà una lista di contatti corrispondenti ai
              profili che hai targettizzato su LinkedIn.
              <br />
            </p>
            <p>
              Per realizzare l'importazione dei tuoi contatti LinkedIn, clicca
              sul link:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/linkedin
              </a>{" "}
              poi clicca su Ricerca su LinkedIn
            </p>
            <p>O vai sulla scheda “Contatto“ &gt; Ricerca su LinkedIn</p>
            <p>Hai così diverse possibilità: </p>
            <b>
              {" "}
              Estrarre contatti a partire da una ricerca LinkedIn/Sales
              Navigator seguendo i passaggi qui sotto:
              <br />
            </b>
            <ol>
              <li> Effettua la tua ricerca su LinkedIn/Sales Navigator. </li>
              <li>
                {" "}
                Copia il link URL della pagina della tua ricerca su LinkedIn o
                Sales Navigator.
              </li>
              <li>
                {" "}
                Incolla nella sezione “URL LinkedIn della ricerca" &gt; Avanti.
              </li>
              <li>
                {" "}
                Scegli il numero di profili da estrarre che dovrà essere
                superiore o uguale al numero di contatti trovati alla fine della
                tua ricerca &gt; Avanti.
              </li>
              <li>
                {" "}
                Seleziona l'account LinkedIn con il quale desideri estrarre i
                contatti &gt; Avanti
              </li>
              <li> Dai un nome alla tua lista.</li>
              <li>
                {" "}
                Spunta la casella arricchisci la mia lista se desideri ottenere
                gli indirizzi email professionali dei tuoi contatti. &gt;
                Avanti. <br />
              </li>
            </ol>
            <p>
              {" "}
              <b>Nota </b>: Il sistema sta importando la tua lista, ci vogliono
              20 minuti per estrarre 2000 contatti, ritroverai la tua lista in
              “Contatti”{" "}
            </p>
            <p>
              <b>
                Estrarre contatti che hanno commentato/messo 'mi piace' a un
                post su LinkedIn seguendo i passaggi qui sotto:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                In LinkedIn, una volta sul post di tua scelta, clicca sui 3
                puntini in alto a destra del post e seleziona “Copia il link del
                post”{" "}
              </li>
              <li>
                {" "}
                In {reseller?.name}, su “Contatti” poi “Targeting” poi “Ricerca
                su LinkedIn” seleziona “Estrarre contatti che hanno commentato
                un post su LinkedIn” o “Estrarre contatti che hanno messo 'mi
                piace' a un post su LinkedIn”
              </li>
              <li>
                {" "}
                Incolla il link URL nella sezione “URL LinkedIn della ricerca”.
              </li>
              <li>
                {" "}
                Scegli il numero di profili da estrarre che dovrà essere
                superiore o uguale al numero di contatti trovati alla fine della
                tua ricerca &gt; Avanti.{" "}
              </li>
              <li>
                {" "}
                Seleziona l'account LinkedIn con il quale desideri estrarre i
                contatti.&gt; Avanti.
              </li>
              <li> Dai un nome alla tua lista &gt; Avanti</li>
              <li>
                {" "}
                Spunta la casella arricchisci la mia lista se desideri ottenere
                gli indirizzi email professionali dei tuoi contatti.
              </li>
              <li>
                {" "}
                Il sistema importa la tua lista, ritroverai la tua lista in
                “Contatti”
                <br />
              </li>
            </ol>
            <p>
              {" "}
              <b>
                Estrarre contatti connessi alla tua rete LinkedIn (livello 1)
                seguendo i passaggi qui sotto:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                In {reseller?.name}, su “Targeting” poi “Ricerca su LinkedIn”
                seleziona “Estrarre le tue connessioni su LinkedIn”
              </li>
              <li> Specifica il numero di profili da importare </li>
              <li>
                {" "}
                Seleziona l'account LinkedIn con il quale desideri estrarre i
                contatti.&gt; Avanti
              </li>
              <li> Dai un nome alla tua lista &gt; Avanti</li>
              <li>
                {" "}
                Spunta la casella arricchisci la mia lista se desideri ottenere
                gli indirizzi email professionali dei tuoi contatti.
              </li>
              <li>
                {" "}
                Il sistema importa la tua lista, ritroverai la tua lista in
                “Contatti”
              </li>
            </ol>
            <p>
              <b>
                Estrarre i publisher di offerte di lavoro su LinkedIn seguendo i
                passaggi qui sotto:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                Lancia la tua ricerca di lavoro su LinkedIn selezionando
                “lavori” in LinkedIn.
              </li>
              <li> Copia il link della tua ricerca.</li>
              <li>
                {" "}
                Incolla questo link in {reseller?.name}, su “Targeting” poi
                “Ricerca su LinkedIn” poi “Estrarre i publisher di offerte di
                lavoro su LinkedIn”
              </li>
              <li>
                {" "}
                Scegli il numero di profili da estrarre che dovrà essere
                superiore o uguale al numero di contatti trovati alla fine della
                tua ricerca &gt; Avanti.{" "}
              </li>
              <li>
                {" "}
                Seleziona l'account LinkedIn con il quale desideri estrarre i
                contatti.&gt; Avanti
              </li>
              <li> Dai un nome alla tua lista &gt; Avanti</li>
              <li>
                {" "}
                Spunta la casella arricchisci la mia lista se desideri ottenere
                gli indirizzi email professionali dei tuoi contatti.
              </li>
              <li>
                {" "}
                Il sistema importa la tua lista, ritroverai la tua lista in
                “Contatti”.
              </li>
            </ol>
          </Stack>
        ),
      },
      {
        url: "import-google",
        title: "Creare una lista a partire da Google Maps",
        content: (
          <Stack>
            <p>
              Con {reseller?.name}, a partire dal tuo account Google, puoi
              creare delle liste di contatti a partire da una ricerca su Google
              Maps seguendo i passaggi qui sotto:
            </p>
            <p>
              {" "}
              <br />
              Puoi creare una lista di contatti a partire da una ricerca su
              Google Maps tramite il seguente link:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/google`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/google
              </a>{" "}
              <br />O vai sulla scheda “Targeting &gt; Google”
            </p>
            <p>
              <br />
            </p>
            <ol>
              <li>
                Vai su Google Maps per fare una ricerca inserendo i tuoi
                elementi di ricerca, ovvero la funzione e la situazione
                geografica: Esempio Informatica a Parigi.{" "}
                <a
                  href={`https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/
                </a>{" "}
                <br /> <br />
              </li>
              <li>
                {" "}
                Nella barra di ricerca del tuo browser, copia il link URL della
                pagina della tua ricerca Google Maps. Esempio:{" "}
                <a
                  href={`https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu
                </a>
                <br />
              </li>
              <li>
                {" "}
                Incolla il link URL in {reseller?.name} sulla scheda “Targeting
                &gt; Google” al fine di estrarre i risultati di una ricerca su
                Google Maps.
                <br />
              </li>
              <li>
                Seleziona il tuo account Google che hai configurato. <br />
              </li>
              <li>
                {" "}
                Scegli il numero di risultati / profili da estrarre.
                <br />
              </li>
              <li>
                {" "}
                Dai un nome alla tua lista al fine di salvarla o seleziona la
                cartella e una lista di contatti esistente.
                <br />
                Il sistema importerà la tua lista che ritroverai nella scheda
                “Contatti”.
                <br />
                Puoi anche spuntare l'opzione di arricchimento ''Arricchire base
                fuori Francia'' della tua lista al fine di completarla con
                informazioni legali e aggiungervi le mail per liste estere{" "}
                <br />
              </li>
            </ol>
          </Stack>
        ),
      },
      {
        url: "import-database",
        title: "Creare una lista a partire dalla base di contatti",
        content: (
          <Stack>
            <p>
              Hai la possibilità sulla piattaforma di creare una lista di
              contatti a partire dalla nostra base di diversi milioni di
              contatti BtoB.
              <br />
            </p>
            <p>
              Per creare una lista di contatti a partire dalla nostra base di
              dati cliccando sul seguente link:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/base`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/base
              </a>{" "}
              <br />
            </p>
            <p>
              O vai sulla scheda <b>Targeting</b>
            </p>
            <ul>
              <li>
                Hai così la possibilità di affinare la tua ricerca aggiungendo
                più criteri come la funzione, il dominio d'attività e ancora la
                zona geografica.
              </li>
              <li>
                Puoi anche filtrare la tua lista precisando il codice NAF,
                l'attività dell'azienda, la sua cifra d'affari, la sua forma
                giuridica, la sua presenza sul web: Clicca ogni volta sulla
                freccia blu accanto a ogni filtro per aggiungere la tua scelta.
              </li>
            </ul>
            <p>
              <br />
              Per registrare i contatti trovati sulla tua lista, Clicca sul
              pulsante “registrare” a destra dei profili che appaiono.
              <br />
            </p>
            <p>
              <b>Nota </b>: hai la possibilità di creare o di aggiungere questi
              contatti a una lista già creata.
              <br />
            </p>
            <p>
              La tua lista è così aggiunta in cliccando sul seguente link:{" "}
              <a
                href={`https://{
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists
              </a>{" "}
            </p>
            <p>
              O vai sulla pagina <b>Contatti</b>
            </p>
          </Stack>
        ),
      },
      {
        url: "linkedin-import-not-working",
        title: "L'importazione dei contatti LinkedIn non funziona",
        content: (
          <Stack>
            <p>
              Se la tua importazione LinkedIn non funziona, puoi verificare
              questi punti:
            </p>
            <p>
              <br />
              1.Vai su{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/senders/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /senders/linkedin
              </a>
            </p>
            <p>O in “Configurazioni” poi “Account LinkedIn” </p>
            <ul>
              <li>
                Verifica che il tuo account sia sempre connesso
                <br />
                Se no, riattualizza il cookie di connessione
                <br />
              </li>
            </ul>
            <p></p>
            <p>
              2. Vai su{" "}
              <a
                href={`https://{
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/linkedin <br />
              </a>
            </p>
            <p>
              O in ''Targeting'' &gt; ''LinkedIn''
              <br />
            </p>
            <ul>
              <li>
                <b>A</b> : Verifica che il link importato sia compatibile con la
                natura del tuo account LinkedIn (un account non Sales Navigator
                non può importare un link Sales Navigator)
                <br />
              </li>
            </ul>
            <ul>
              <li>
                <b>B</b> : Verifica che il formato del link sia quello richiesto
                dal sistema al momento della creazione della lista
              </li>
            </ul>
            <p></p>
            <p>
              Se la tua importazione non funziona ancora, non esitare a
              sollecitarci, siamo qui per aiutarti!
            </p>
          </Stack>
        ),
      }
    );
    result[5].items.push({
      url: "cname-error",
      title: "Messaggi di errore CNAME",
      content: (
        <Stack>
          <p>
            <b>Domanda </b>: Ho questo messaggio di errore quando voglio
            accedere alla mia marca bianca
          </p>
          <p>{`{"state":false,"state_message":"action_not_exist","documentation":null}`}</p>
          <p>
            <br />
          </p>
          <p>
            <b>Risposta </b>: Forse non hai inserito bene i parametri nel
            software o nella redirezione CNAME del tuo dominio.
            <br />
            Questo problema proviene sempre da un errore di configurazione.
          </p>
          <p>
            <br />
            <b>Consultare i record CNAME presso il tuo host di dominio</b>
          </p>
          <ul>
            <li>
              Sottodominio mail digitato nel tuo dominio CNAME
              <br />
              <br />
              <b>Consultare i parametri nel software</b>
              <br />
            </li>
            <li>Errore di inserimento del nome di dominio nel software</li>
          </ul>
          <p>
            <br />
          </p>
          <p>
            Soluzione di verifica: Eseguire <b>nslookup </b>sul tuo computer
            <br />
            <br />
          </p>
          <p>
            L'applicazione nslookup è disponibile sulla maggior parte dei
            sistemi operativi. <br />
            Permette di cercare le informazioni concernenti i server dei nomi
            utilizzando una linea di comando sotto Microsoft Windows, Apple Mac
            o Linux.
            <br />
            <br />
            Per eseguire la linea di comando sotto Windows, clicca su Start &gt;
            Esegui.
          </p>
          <ul>
            <li>Digita cmd, poi premi Invio.</li>
            <li> Sotto Mac o Linux, avvia il terminale.</li>
            <li> Digita il seguente comando:</li>
            <li>
              {" "}
              nslookup -q=cname{" "}
              <a href={`saas.example.com`} target="_blank" rel="noreferrer">
                saas.example.com
              </a>{" "}
            </li>
            <li>
              {" "}
              Sostituisci{" "}
              <a href={`http://example.com`} target="_blank" rel="noreferrer">
                example.com
              </a>{" "}
              con il nome del dominio contenente il record CNAME che desideri
              consultare.
              <br />
              <br />
            </li>
          </ul>
          <p>
            {" "}
            Interpreta il risultato come nell'esempio seguente,{" "}
            <a href={`example.com`} target="_blank" rel="noreferrer">
              example.com
            </a>{" "}
            :
          </p>
          <p>
            {" "}
            nslookup -q=cname <a href={`saas.exemple.com`}>saas.exemple.com</a>
          </p>
          <p>
            {" "}
            <br />
            Con questo esempio, otteniamo i seguenti dati:
          </p>
          <p> Server: box </p>
          <p> Address: 192.168.1.1</p>
          <p> Risposta non autorevole:</p>
          <p>
            {" "}
            <a href={`saas.exemple.com`} target="_blank" rel="noreferrer">
              saas.exemple.com
            </a>
            canonical name =
            <a
              href={`resellers-pool1.staging.magileads.net`}
              target="_blank"
              rel="noreferrer"
            >
              resellers-pool1.staging.magileads.net
            </a>
            .
          </p>
          <p>
            {" "}
            <br />
            Le informazioni ricercate figurano nelle due ultime righe. <br />
            Più precisamente, il risultato ci indica che{" "}
            <a href={`saas.exemple.com`} target="_blank" rel="noreferrer">
              saas.exemple.com
            </a>{" "}
            punta verso il nome r
            <a
              href={`resellers-pool1.staging.magileads.net.`}
              target="_blank"
              rel="noreferrer"
            >
              esellers-pool1.staging.magileads.net.
            </a>
          </p>
          <p>
            <br />
          </p>
          <p>
            Puoi anche testare i tuoi sottodomini su questo link se conosci l'IP
            del tuo host:{" "}
            <a
              href={`https://www.saas-secure.com/online-services/nslookup.html`}
              target="_blank"
              rel="noreferrer"
            >
              https://www.saas-secure.com/online-services/nslookup.html
            </a>
          </p>
          <p>
            <br />
          </p>
          <p></p>
        </Stack>
      ),
    });
  }

  return result;
}
